import { Box, Checkbox, Flex, Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";

import classes from "./WatchList.module.css";

import type { MarketCar } from "@/types/market";
import type { Watchlist, Watchlists } from "@/types/watchlist";
import type { FC } from "react";

interface WatchlistSelectionBoxProps {
  carToAdd: MarketCar | null;
  selectedWatchlists: string[];
  setSelectedWatchlists: React.Dispatch<React.SetStateAction<string[]>>;
  watchlists: Watchlists | undefined;
  addCarToWatchlistHandler?: (watchlistIds: string[]) => void;
  removeCarFromWatchlistHandler: (watchlistIdToRemove: string) => void;
}

const WatchlistSelectionBox: FC<WatchlistSelectionBoxProps> = ({
  selectedWatchlists,
  setSelectedWatchlists,
  watchlists,
  addCarToWatchlistHandler,
  removeCarFromWatchlistHandler,
}) => {
  const { t } = useTranslation();

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, watchlistId: string) => {
    e.stopPropagation();
    const checked = e.currentTarget.checked;

    setSelectedWatchlists((prev) => {
      if (checked) {
        if (prev.includes(watchlistId)) return prev;
        addCarToWatchlistHandler?.([watchlistId]);
        return [...prev, watchlistId];
      } else {
        removeCarFromWatchlistHandler(watchlistId);
        return prev.filter((id) => id !== watchlistId);
      }
    });
  };

  return (
    <Box
      onClick={(e) => e.stopPropagation()}
      style={{
        overflow: "auto",
        maxHeight: "20em",
      }}
    >
      <Stack my="sm">
        {watchlists?.map((item: Watchlist) => {
          const isChecked = selectedWatchlists.includes(item.id);

          return (
            <Flex
              key={item.id}
              align="center"
              className={classes.radioBox}
              p={0}
              style={{ cursor: "pointer" }}
            >
              <Checkbox
                checked={isChecked}
                pl="xs"
                onChange={(e) => handleCheckboxChange(e, item.id)}
                label={item.name}
                tabIndex={0}
                aria-label={t("components.WatchList.add_to_watchlist", {
                  name: item.name,
                })}
              />
            </Flex>
          );
        })}
      </Stack>
    </Box>
  );
};

export default WatchlistSelectionBox;
